import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react';
import { PiPaperPlaneBold } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button as ButtonScroll } from 'react-scroll';
import { formattedCurrency } from '../../../helper/utils/formattedCurrency';
import { urlNavigate } from '../../../helper/utils/navigation';
import { isCartContainRecurring } from '../../../redux/utils/menuItem';
import useCartDatas from '../hooks/useCartDatas';

export default function FloatingCheckoutButton({ to }) {
    const { getGrandtotal, cart } = useCartDatas();
    const navigate = useNavigate();
    const location = useLocation();

    const splittedPath = location.pathname.split('/');
    const lastPath = splittedPath[splittedPath.length - 1];
    const isAddons = lastPath == 'add-ons';
    const isSubscription = isCartContainRecurring(cart);

    if (cart.length == 0) {
        return null;
    }

    return (
        <Box w='full' h='auto' position='fixed' bottom={0} left={0} zIndex={999} display={{ base: 'block', md: 'none' }}>
            <Box bg='white' roundedTop='xl' p={3} boxShadow='0 -10px 30px 0 rgba(0, 0, 0, 0.2)' border='1px' borderColor='gray.100'>
                <Flex w='full' alignItems='center' justifyContent='space-between'>
                    <Text color='gray'>Grand Total</Text>
                    <Text fontSize='18px' fontWeight={800}>
                        {formattedCurrency(getGrandtotal())}
                    </Text>
                </Flex>
                <Flex w='full' gap={2} mt={5}>
                    <Button as={ButtonScroll} to='cart' smooth={true} delay={300} offset={-50} w='full' size='lg' colorScheme='gray' variant='outline' fontSize='15px' py={7} rounded='lg'>
                        Show Detail
                    </Button>
                    <Button
                        isDisabled={cart.length == 0}
                        rightIcon={<Icon as={PiPaperPlaneBold} transform='rotate(90deg)' fontSize='20px' />}
                        fontWeight={800}
                        w='full'
                        size='lg'
                        colorScheme='primary'
                        variant='solid'
                        fontSize='15px'
                        py={7}
                        rounded='lg'
                        onClick={() => {
                            if (isAddons || isSubscription) {
                                navigate(`${urlNavigate('online-sales', 'checkout')}`);

                                return;
                            }

                            navigate(`${urlNavigate('online-sales', 'add-ons')}`);
                        }}>
                        Checkout
                    </Button>
                </Flex>
            </Box>
        </Box>
    );
}
